import { render, staticRenderFns } from "./GoodByeMessage.vue?vue&type=template&id=2c12bc69"
import script from "./GoodByeMessage.vue?vue&type=script&lang=js"
export * from "./GoodByeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports